import React from 'react';

export default function JobBoard() {
  return (
    <div>
      <h2>Job Board</h2>
      <p>Find jobs and internships from top employers in the AI economy.</p>
    </div>
  );
}
